import {
  isInvalidPurchaseOrderNumber,
  isInvalidString,
  isInvalidWarehouseCheckInId
} from "src/validation/stringValidation";
import { FormValidator } from "./formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { ResolveIssueFormDataKey } from "src/types";

class IssueResolutionFormValidator extends FormValidator {
  private static validateId(value: unknown): ValidationError<"id"> | undefined {
    return isInvalidPurchaseOrderNumber(value) && isInvalidWarehouseCheckInId(value)
      ? new ValidationError("Enter a valid purchase order number (e.g., 'PO-2055')", "id")
      : undefined;
  }

  private static validateResolutionDetails(value: unknown): ValidationError<"resolutionDetails"> | undefined {
    return isInvalidString(value, 2, 500)
      ? new ValidationError("Enter valid resolution details", "resolutionDetails")
      : undefined;
  }

  private static readonly validationStrategies: Record<
    ResolveIssueFormDataKey,
    (value: unknown) => ValidationError<ResolveIssueFormDataKey> | undefined
  > = {
    id: IssueResolutionFormValidator.validateId,
    resolutionDetails: IssueResolutionFormValidator.validateResolutionDetails
  };

  static validateIssueResolutionFormData<T extends ResolveIssueFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(formData, IssueResolutionFormValidator.validationStrategies) as ValidationErrors<T>;
  }
}

export { IssueResolutionFormValidator };
